.container {
  display: inline-block;
}
